export default __webpack_public_path__ + "static/daily-huddle-ecf9a909cd960bae86bbed4d778db78a.png";